import isEmpty from "lodash/isEmpty";
import { useQuery } from "react-query";
import { useSpaceSlugFromUrl } from "@/react/hooks/useSpaceSlugFromUrl";
import { useSpacesContext } from "@circle-react/contexts";
import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";
import type { Space } from "@circle-react/types";

const STALE_TIME_IN_MS = 1800 * 1000;

export const useChatSpaceMembers = () => {
  const spaceSlug = useSpaceSlugFromUrl();
  const space: Space | null =
    useSpacesContext().helpers.findBy({ slug: spaceSlug }) || null;
  const {
    data = {} as any,
    isLoading: isLoadingSpaceMembers,
    refetch: refetchSpaceMembers,
  } = useQuery(internalApi.spaceMembers.sidebar({ spaceId: space?.id }), {
    staleTime: STALE_TIME_IN_MS,
  });
  const isLoading = isLoadingSpaceMembers || isEmpty(space);
  const { records: spaceMembers = [], has_more_space_members } = data;

  return {
    space,
    isLoading,
    spaceMembers,
    has_more_space_members,
    refetchSpaceMembers,
  };
};
